document.addEventListener("DOMContentLoaded", () => {
  // ---------------------------------------
  // MAIN CAROUSEL SLIDER
  // ---------------------------------------

  const carousel = document.querySelector(".carousel");
  const carouselSlider = document.querySelector(".carousel_slider");
  const mediaCarouselContainer = document.querySelector(
    ".media_carousel_slider"
  );
  const carouselTrackers = document.querySelectorAll(".carousel_tracker");
  const carouselSlides = document.querySelectorAll(".carousel_slide");

  // Set initial active classes
  carouselTrackers[0].classList.add("active");
  carouselSlides[0].classList.add("active");

  let carouselSlideWidth = carouselSlider.clientWidth;
  carouselSlides.forEach((slide) => {
    slide.style.width = carouselSlideWidth + "px";
    slide.style.height = carouselSlideWidth + "px";
    slide.style.minWidth = carouselSlideWidth + "px";
    slide.style.minHeight = carouselSlideWidth + "px";
  });

  // ---------------------------------------
  // THUMBNAIL CAROUSEL SLIDER
  // ---------------------------------------
  const thumbnailTrackerWrapper = document.querySelector(
    ".thumbnails_trackers_wrapper"
  );
  const thumbnailTrackers = document.querySelectorAll(".thumbnail_tracker");
  const thumbnailSlides = document.querySelectorAll(".thumbnail_slide");
  const mediaThumbnails = document.querySelectorAll(
    ".thumbnail_media_slides .thumbnail_slide"
  );
  // Set initial active classes
  thumbnailTrackers[0].classList.add("active");
  thumbnailSlides[0].classList.add("active");

  // ---------------------------------------
  // MAIN FUNCTIONS
  // ---------------------------------------

  window.addEventListener("load", adjustHeightAndWidth);

  function adjustHeightAndWidth() {
    const carouselContainer = document.querySelector(".carousel_slider");
    const thumbnailSlider = document.querySelector(".thumbnail_slider");
    const images = document.querySelectorAll(".carousel_slide img");

    if (carouselContainer && images.length > 0) {
      const maxHeight = Math.max(
        ...Array.from(images).map((img) => img.offsetHeight)
      );
      carouselContainer.style.height = maxHeight + "px";
      mediaCarouselContainer.style.height = maxHeight + "px";
      if (window.innerWidth > 992) {
        thumbnailSlider.style.height = maxHeight + "px";
        carousel.style.height = maxHeight + "px";
        carouselSlider.style.width = maxHeight + "px";
      }
      if (window.innerWidth > 992) {
        const thumbnailSliderHeight = thumbnailSlider.clientHeight;
        if (mediaThumbnails.length === 2) {
          const calculatedHeight = ((thumbnailSliderHeight - 0) / 7) * 5;
          thumbnailTrackerWrapper.style.height = calculatedHeight + "px";
        } else if (mediaThumbnails.length === 1) {
          const calculatedHeight = ((thumbnailSliderHeight - 0) / 7) * 6;
          thumbnailTrackerWrapper.style.height = calculatedHeight + "px";
        } else {
          thumbnailTrackerWrapper.style.height = maxHeight + "px";
        }
      }
    }
  }

  function setActiveThumbnail(index) {
    const activeTracker = document.querySelector(".thumbnail_tracker.active");
    const activeCarousel = document.querySelector(".carousel_tracker.active");
    const thumbnailSlides = activeTracker.querySelectorAll(".thumbnail_slide");

    thumbnailSlides.forEach((thumbnail, i) => {
      thumbnail.classList.toggle("active", i === index);
    });

    if (activeCarousel) {
      const carouselSlides = activeCarousel.querySelectorAll(".carousel_slide");
      const activeClassList = ["fade-in", "active"];
      const inactiveClassList = ["fade-out"];

      carouselSlides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add(...activeClassList);
          slide.classList.remove(...inactiveClassList);
        } else {
          slide.classList.add(...inactiveClassList);
          slide.classList.remove(...activeClassList);
        }
      });
    }
  }

  function scrollThumbnails(index) {
    const activeTracker = document.querySelector(".thumbnail_tracker.active");
    const newThumbnailSlides =
      activeTracker.querySelectorAll(".thumbnail_slide");
    const numThumbnailsVisible = 5;
    const lastIndex = newThumbnailSlides.length - numThumbnailsVisible;
    const clampedIndex = Math.max(0, Math.min(index, lastIndex));

    if (window.innerWidth <= 992) {
      const thumbWidth = newThumbnailSlides[0].offsetWidth + 10;
      activeTracker.scrollTo({
        left: clampedIndex * thumbWidth,
        behavior: "smooth",
      });
    } else {
      const thumbHeight = newThumbnailSlides[0].offsetHeight + 10;
      thumbnailTrackerWrapper.scrollTo({
        top: clampedIndex * thumbHeight,
        behavior: "smooth",
      });
    }
  }

  // ---------------------------------------
  // Event Listeners
  // ---------------------------------------

  thumbnailTrackers.forEach((tracker, index) => {
    const activeSlides = tracker.querySelectorAll(".thumbnail_slide");
    activeSlides.forEach((thumbnail, thumbnailIndex) => {
      thumbnail.addEventListener("click", () => {
        if (mediaCarouselContainer.classList.contains("active")) {
          mediaCarouselContainer.classList.remove("active");
        }
        setActiveThumbnail(thumbnailIndex);
        scrollThumbnails(thumbnailIndex, tracker);
      });
    });
  });

  mediaThumbnails.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const mediaSlides = document.querySelectorAll(
        ".media_carousel_slider .carousel_video_tracker, .media_carousel_slider .carousel_view3d_tracker"
      );

      carouselSlides.forEach((slide) => {
        slide.classList.remove("active");
      });
      thumbnailSlides.forEach((slide) => {
        slide.classList.remove("active");
      });
      v;
      mediaCarouselContainer.classList.add("active");

      mediaSlides.forEach((slide) => {
        const isVideoThumb =
          thumb.classList.contains("thumbnail_video") &&
          slide.classList.contains("carousel_video_tracker");
        const is3DThumb =
          thumb.classList.contains("thumbnail_3d") &&
          slide.classList.contains("carousel_view3d_tracker");

        if (isVideoThumb || is3DThumb) {
          slide.classList.add("fade-in", "active");
          slide.classList.remove("fade-out");
        } else {
          slide.classList.add("fade-out");
          slide.classList.remove("fade-in", "active");
        }
      });
    });
  });

  // ---------------------------------------
  // Carousel Swipe Left/Right
  // ---------------------------------------
  carouselTrackers.forEach((tracker) => {
    const trackerWidth = carouselSlides.length * carouselSlideWidth;
    tracker.style.width = trackerWidth + "px";
    const activeCarouselSlides = Array.from(
      tracker.querySelectorAll(".carousel_slide")
    );
    const activeThumbnailTracker = document.querySelector(
      ".thumbnail_tracker.active"
    );
    const activeThumbnailSlides = Array.from(
      activeThumbnailTracker.querySelectorAll(".thumbnail_slide")
    );
    tracker.addEventListener("touchstart", handleTouchStart, false);
    tracker.addEventListener("touchmove", handleTouchMove, false);

    let startX, startY;

    function handleTouchStart(event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }

    function handleTouchMove(event) {
      if (!startX || !startY) {
        return;
      }

      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;

      const diffX = startX - currentX;
      const diffY = startY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) {
          handleSwipe(1);
        }
        // Swipe right
        else {
          handleSwipe(-1);
        }
      }
      startX = null;
      startY = null;

      event.preventDefault();
    }

    function handleSwipe(direction) {
      const activeSlide = tracker.querySelector(".carousel_slide.active");
      const correspondingThumbnailTracker = document.querySelector(
        `.thumbnail_tracker[data-tracker="${tracker.dataset.tracker}"]`
      );
      const activeThumbnailSlides = Array.from(
        correspondingThumbnailTracker.querySelectorAll(".thumbnail_slide")
      );
      const activeThumbnailSlide = correspondingThumbnailTracker.querySelector(
        ".thumbnail_slide.active"
      );

      if (activeSlide) {
        const currentSlideIndex = activeCarouselSlides.indexOf(activeSlide);
        const newSlideIndex = currentSlideIndex + direction;
        if (newSlideIndex >= 0 && newSlideIndex < activeCarouselSlides.length) {
          activeSlide.classList.remove("active");
          activeSlide.classList.add("fade-out");
          activeCarouselSlides[newSlideIndex].classList.add(
            "active",
            "fade-in"
          );
        }
      }

      if (activeThumbnailSlide) {
        const currentThumbnailSlideIndex =
          activeThumbnailSlides.indexOf(activeThumbnailSlide);
        const newScrollIndex = currentThumbnailSlideIndex + direction;
        if (
          newScrollIndex >= 0 &&
          newScrollIndex < activeThumbnailSlides.length
        ) {
          activeThumbnailSlide.classList.remove("active");
          activeThumbnailSlides[newScrollIndex].classList.add("active");
        }
        scrollThumbnails(newScrollIndex);
      }
    }
  });
});
